import { useQuery } from "@tanstack/react-query";
import { CACHE_TIMES } from "@/lib/queryConfig";
import { fetchDecorationCatalog } from "./decoration-catalog.api";
import type { DecorationCatalog } from "../shared/design-catalog.types";

export const DECORATION_CATALOG_QUERY_KEY = [
  "catalog",
  "get-print-type-decorations",
  "v2",
] as const;

type Options = {
  enabled?: boolean;
};

export function useDecorationCatalogQuery(options: Options = {}) {
  return useQuery<DecorationCatalog>({
    queryKey: DECORATION_CATALOG_QUERY_KEY,
    queryFn: fetchDecorationCatalog,
    enabled: options.enabled ?? true,
    ...CACHE_TIMES.CONFIG,
    refetchOnWindowFocus: false,
  });
}
